import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import { UserProvider } from './contexts/UserContext';
import './App.css'
import { onMessageListener } from './services/firebase';
import { notification } from 'antd'; // Ant Design bildirim bileşeni
import { BellOutlined } from '@ant-design/icons'; // Eksik olan import eklendi

const ProtectedRoute = ({ element }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (!user) {
      navigate('/login');
    } else {
      setIsLoading(false);
    }
  }, [navigate]);

  if (isLoading) {
    return null;
  }

  return element;
};

function App() {
  // useEffect uygulama bileşeninin (App) içinde olmalıdır
  useEffect(() => {
    onMessageListener()
      .then((payload) => {
        // Uygulama açıkken sağ üstte bildirim kutusu açar
        notification.info({
          message: payload.notification.title,
          description: payload.notification.body,
          placement: 'topRight',
          icon: <BellOutlined style={{ color: '#1677ff' }} />,
        });
        console.log("Ön planda bildirim alındı:", payload);
      })
      .catch((err) => console.log('Bildirim dinlenirken hata:', err));
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        {/* UserProvider'ı tüm route'ları kapsayacak şekilde de konumlandırabilirsiniz */}
        <Route path="/" element={
          <UserProvider>
            <ProtectedRoute element={<HomePage />} />
          </UserProvider>
        } />
      </Routes>
    </Router>
  );
}

export default App;